import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditProcessComponent } from './edit-process/edit-process.component';
import { FetchProcessesComponent } from './fetch-processes/fetch-processes.component';


const routes: Routes = [
  {
    path: 'processes/new',
    component: EditProcessComponent
  },
  {
    path: 'processes',
    component: FetchProcessesComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
